import React, { Component } from "react";
import CustomLink from "@/components/custom-link-react";
import Text from "@gerenciatd/next13.components.text";
import getColor from "@gerenciatd/next13.enums.colors";
import OpenIcon from "@gerenciatd/next13.glyph.cheuron-down-m";
import CloseIcon from "@gerenciatd/next13.glyph.cheuron-up-m";

class MenuGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupOpened: false,
    };
  }

  handleClick = () => {
    this.setState({
      groupOpened: !this.state.groupOpened,
    });
  };

  render() {
    const { item } = this.props;
    const items = item["sections"];
    let i = 0;
    if (!item) {
      return null;
    }
    return (
      <>
        <div className="menu-group">
          <div className="menu-group-header" onClick={this.handleClick}>
            <div className="text-gap">
              <Text
                text={item.text}
                fontType="font-regular"
                size="caption01"
                color="grey5"
                display="block"
              />
            </div>
            <div className="icon-gap">
              {!this.state.groupOpened && (
                <OpenIcon width="12px" height="12px" color="grey5" />
              )}
              {this.state.groupOpened && (
                <CloseIcon width="12px" height="12px" color="grey5" />
              )}
            </div>
          </div>
          {this.state.groupOpened && (
            <div className="sections">
              {items.map((subitem) => {
                const link = subitem.link ? item.link : "#";
                const text = subitem.text;
                return (
                  <div key={`item-${i++}`} className="menu-item">
                    <CustomLink
                      href={link}
                      title=""
                      ariaLabel=""
                      taggingInfo={{
                        componentName: "header",
                        componentContent: "menu",
                        componentVariation: "all",
                        componentPerso: "",
                        componentProduct: "",
                      }}
                    >
                      <Text
                        text={text}
                        fontType="font-regular"
                        size="caption01"
                        color="grey5"
                        display="block"
                      />
                    </CustomLink>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </>
    );
  }
}

export default MenuGroup;
